export function successNotification(summary, message) {
  return {
    severity: NOTIFICATION_SEVERITY.SUCCESS,
    summary: summary,
    detail: message
  }
}

export function errorNotification(summary, message) {
  return {
    severity: NOTIFICATION_SEVERITY.ERROR,
    summary: summary,
    detail: message,
    life: 5000
  }
}

export function warningNotification(summary, message) {
  return {
    severity: NOTIFICATION_SEVERITY.WARNING,
    summary: summary,
    detail: message,
    life: 5000
  }
}

export function infoNotification(summary, message) {
  return {
    severity: NOTIFICATION_SEVERITY.INFO,
    summary: summary,
    detail: message
  }
}

export const NOTIFICATION_SEVERITY = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warn",
  INFO: "info"
}
